import { RequestType } from "./traingPathListDisplayType";
import TraingPathList from "./traingPathList";

const ArchivedTrainingPathList: React.FC = () => {
  return <TraingPathList requestType={RequestType.ARCHIVE} />;
};

export default ArchivedTrainingPathList;
